(function(){
  var root = document.querySelector('[data-tg-body]');
  if(!root) return;
  var scope = root.closest('.tg-nar') || document;
  var step = scope.querySelector('[data-tg-step]');
  var bar  = scope.querySelector('[data-tg-bar]');
  var res  = scope.querySelector('[data-tg-res]');
  var cat  = {};
  try { cat = JSON.parse(scope.querySelector('[data-tg-catalog]').textContent); } catch(e){}
  var clinicEl = scope.querySelector('[data-tg-clinic]');
  var clinic = clinicEl ? clinicEl.textContent.trim() : '';

  var Q = [
    { q:'Are you on a protocol prescribed by a clinician?',
      n:'We will not ask which one. That conversation belongs with the person who prescribed it, not with a shopping page.',
      a:[['Yes','rx'],['No','norx'],['Not yet, considering it','maybe']] },
    { q:'Has your appetite or food intake changed?',
      n:'Eating less means absorbing less of everything, not just calories.',
      a:[['Eating noticeably less','intake2'],['Somewhat less','intake1'],['No real change','none']] },
    { q:'How much are you training right now?', n:'',
      a:[['Four or more sessions a week','train2'],['One to three','train1'],['Not currently','none']] },
    { q:'Any digestive discomfort?', n:'',
      a:[['Regularly','gut2'],['Occasionally','gut1'],['No','none']] },
    { q:'How is your sleep?', n:'',
      a:[['Poor most nights','sleep2'],['Broken, but I get by','sleep1'],['Fine','none']] }
  ];

  var i = 0, tags = [];
  function has(t){ return tags.indexOf(t) > -1; }

  function render(){
    if(i >= Q.length) return done();
    var it = Q[i];
    if(step) step.textContent = 'Question ' + (i+1) + ' of ' + Q.length;
    if(bar) bar.style.width = (i / Q.length * 100) + '%';
    var h = '<div class="tg-qq">' + it.q + '</div>';
    if(it.n) h += '<p class="tg-qnote">' + it.n + '</p>';
    it.a.forEach(function(o){
      h += '<button type="button" class="tg-qopt" data-t="' + o[1] + '"><span>' + o[0] + '</span><span class="ar">&rarr;</span></button>';
    });
    root.innerHTML = h;
    Array.prototype.forEach.call(root.querySelectorAll('.tg-qopt'), function(b){
      b.addEventListener('click', function(){ tags.push(b.getAttribute('data-t')); i++; render(); });
    });
    if(i > 0){ var f = root.querySelector('.tg-qopt'); if(f) f.focus(); }
  }

  function done(){
    if(bar) bar.style.width = '100%';
    if(step) step.textContent = 'Your foundations';
    var k = [];
    if(has('intake2')){ k.push('multi','whey'); } else if(has('intake1')){ k.push('multi'); }
    if(has('train2')){ k.push('hydra','crea'); } else if(has('train1')){ k.push('hydra'); }
    if(has('gut2')){ k.push('enz','glp'); } else if(has('gut1')){ k.push('enz'); }
    if(has('sleep2')){ k.push('mag','sleep'); } else if(has('sleep1')){ k.push('mag'); }
    if(!k.length) k = ['multi','mag'];
    k = k.filter(function(v,x,a){ return a.indexOf(v) === x && cat[v]; }).slice(0,6);

    var h = '<div class="tg-qq">Start with these.</div>';
    h += '<p class="tg-qnote">Based on what you told us. Not a diagnosis, and not a substitute for testing or for your clinician.</p>';
    h += '<div class="tg-res">';
    k.forEach(function(id){
      var p = cat[id];
      h += '<a href="' + p.u + '" style="text-decoration:none;color:inherit">';
      if(p.img) h += '<img class="tg-float" src="' + p.img + '" alt="" loading="lazy">';
      h += '<div class="why">' + p.w + '</div><h3>' + p.n + '</h3><p>' + p.d + '</p><div class="pr">' + p.p + '</div></a>';
    });
    h += '</div>';
    if((has('rx') || has('maybe')) && clinic){
      h += '<div class="tg-note"><h3>Bring this list to your clinician</h3><p>Because you told us a protocol is involved, take these to whoever is managing it before you add anything. How your protocol and your nutrition fit together is a clinical question, and the clinic team answers it in a consultation rather than on a product page.</p><div style="margin-top:22px"><a class="tg-cta fill" href="' + clinic + '">Book a consultation</a></div></div>';
    }
    h += '<button type="button" class="tg-again">Start over</button>';
    root.innerHTML = '';
    res.innerHTML = h;
    res.style.display = 'block';
    var again = res.querySelector('.tg-again');
    if(again) again.addEventListener('click', function(){
      i = 0; tags = []; res.style.display='none'; res.innerHTML=''; render();
    });
  }
  render();
})();
